module.exports = __webpack_public_path__ + "img/bullseye.dbf65eed.png";